export default "__VITE_ASSET__AtwGOdlG__"